export class CustomerInput {
  id: string;
  name: string;
  phoneNumber: string;
  paymentCustomerId!: string | null;
  description: string;
  emailId: string;
  handle: string;
  modifiedAt: string;
  profileImageUrl: string;
  address: CustomerAddress[] = [];

  constructor(
    id: string,
    name: string,
    phoneNumber: string,
    description: string,
    emailId: string,
    handle: string,
    modifiedAt: string,
    profileImageUrl: string,
    address: CustomerAddress[]
  ) {
    this.id = id;
    this.name = name;
    this.phoneNumber = phoneNumber;
    this.description = description;
    this.emailId = emailId;
    this.handle = handle;
    this.modifiedAt = modifiedAt;
    this.profileImageUrl = profileImageUrl;
    this.address = address;
  }
}

export enum CountryCode {
  F_US = '+1',
  F_IN = '+91',
  US = '1',
  IN = '91',
}

export enum Tag {
  HOME = 'HOME',
  OFFICE = 'OFFICE',
  OTHER = 'OTHER',
}

export class CustomerAddress {
  id?: string;
  city: string;
  country?: string;
  line2: string;
  line1: string;
  state: string;
  tag?: string;
  zip: string;
  isNew?: boolean;
}
